/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';

export const APPOINTMENT_RECORD_CREATE = gql`
  mutation appointmentRecordCreate($appointments: [AppointmentRecordCreateInput!]) {
    appointment {
      records(create: $appointments) {
        records {
          id
          startTime
          endTime
        }

        errors
        validations
      }
    }
  }
`;
